import { Component, input, output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Input } from '../input.component';
import { BaseInput } from '../base-input';

@Component({
  selector: 'app-input-number',
  standalone: true,
  imports: [Input],
  template: `
    <app-input
      [color]="currentColor()"
      [size]="currentSize()"
      [rounded]="currentRounded()"
      [label]="label()"
      [required]="required()"
      [placeholder]="placeholder()"
      [spellcheck]="spellcheck()"
      [autocomplete]="autocomplete()"
      [autofocus]="autofocus()"
      [readonly]="readonly()"
      [disabled]="disabled()"
      type="number"
      [(value)]="value"
      [suffix]="suffix()"
      (inputBlur)="numberInputBlur.emit()"
    />
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: InputNumber,
      multi: true,
    },
  ],
})
export class InputNumber
  extends BaseInput<number>
  implements ControlValueAccessor
{
  suffix = input<string>();
  numberInputBlur = output();
}
